import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { TestimonialCardSmall } from "../TestimonialCardSmall";
import { testimonialsSmallData as fallback } from "./data.ts";
import { useSectionsData } from "../../utils/useSectionsData.ts";

interface DynamicTestimonialData {
  img: string;
  name: string;
  tr_title: string;
  tr_text: string;
  tr_days_ago: string;
  verifiedBuyer: string;
}

export const TestimonialsSmall = () => {
  const sections = useSectionsData();
  const staticContent = sections.pp_v7_static_content;
  const verifiedBuyer = staticContent.tr_verified_buyer_label;
  const testimonialsSmallSection =
    sections?.pp_v7_small_testimonials_section?.testimonials_repeater;
  const testimonials: DynamicTestimonialData[] =
    testimonialsSmallSection.length > 0
      ? testimonialsSmallSection
      : fallback.map((item) => ({
          img: item.img,
          name: item.name,
          tr_title: item.tr_title,
          tr_text: item.tr_text,
          tr_days_ago: item.tr_days_ago,
          verifiedBuyer: item.verifiedBuyer,
        }));

  return (
    <PageWrapper backgroundColor="section_light">
      <div className={s.testimonialsCard}>
        {testimonials.map((item, index) => (
          <TestimonialCardSmall
            card={item}
            key={index}
            verifiedBuyer={verifiedBuyer}
          />
        ))}
      </div>
    </PageWrapper>
  );
};
